<template>
<v-dialog v-model="dialog" max-width="700px">
    <v-card>
        <v-card-title>
            <span class="headline">{{ DeleteDialogTitle }}</span>
        </v-card-title>
        <v-card-text>
            <v-container class="apagar">
                    {{ModalDeleteText}}
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :color="$primary" text @click="dialog=false">Cancelar</v-btn>
            <v-btn :color="$primary" text @click="DeleteUtilizadorColheita">Confirmar</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import CRUD from '@/mixins/_CRUD'
import UC from '@/mixins/_UC'
export default {
    mixins: [CRUD, UC],
    props: {
        ModalDeleteText: String,
        DeleteDialogTitle: String,
        MyObject: Object,
        MyIndex: Number,
        Store: String,
    },
    computed: {
        getSession() {
            return this.$store.getters['session/getState']
        }
    },
    data: () => ({
        dialog: false
    }),
    watch: {
    },
    mounted() {
    },
    created() {
        this.$eventBus.$on('DeleteDialogColheita', (state)=>{ this.dialog = state});
    },
}
</script>
<style scoped>
.apagar {
    padding: 0 !important;
    line-height: 30px !important;
    font-size: 17px !important;
}
</style>
